import React from 'react';
import { Button } from 'primereact/button';
import '../assets/css/schedule-conflict.css';

const ScheduleConflictModal = ({
    conflicts = [],
    priorityWarnings = [],
    editingCardId = null,
    onProceed,
    onRequestApproval,
    onApproveTimeline,
    proceedLabel = 'Save anyway',
    showProceed = true,
    actionLoading = false,
}) => {
    const items = [
        ...conflicts.map((c) => ({ ...c, source: 'conflict' })),
        ...priorityWarnings.map((w) => ({ ...w, source: 'priority' })),
    ];

    if (!items.length) return null;

    const spillCardId = conflicts.find((c) => c.card_id)?.card_id;
    const suggestCardId =
        spillCardId || (editingCardId != null ? Number(editingCardId) : null);

    return (
        <div className="alert alert-warning schedule-conflict-panel small">
            <strong>Scheduling conflicts detected</strong>
            <p className="text-muted mt-1 mb-2">
                These are tasks on the assignee&apos;s schedule — not necessarily the task you have
                open. <strong>Review &amp; save</strong> shows due date extensions for spill or
                capacity conflicts, then saves members.
            </p>
            <ul className="mb-2 mt-2">
                {items.map((item, idx) => {
                    const isOtherTask =
                        item.card_id &&
                        editingCardId != null &&
                        Number(item.card_id) !== Number(editingCardId);
                    return (
                        <li key={`${item.type}-${item.card_id || idx}`}>
                            {item.message}
                            {item.execution_priority && (
                                <span className="text-muted"> ({item.execution_priority})</span>
                            )}
                            {item.card_id && (
                                <span className="text-muted d-block">
                                    Task #{item.card_id}
                                    {isOtherTask ? ' — different from the task you are editing' : ''}
                                </span>
                            )}
                            {item.scheduled_start_at && item.scheduled_end_at && (
                                <span className="text-muted d-block">
                                    Scheduled work:{' '}
                                    {new Date(item.scheduled_start_at).toLocaleString('en-IN', {
                                        dateStyle: 'medium',
                                        timeStyle: 'short',
                                    })}{' '}
                                    →{' '}
                                    {new Date(item.scheduled_end_at).toLocaleString('en-IN', {
                                        dateStyle: 'medium',
                                        timeStyle: 'short',
                                    })}
                                </span>
                            )}
                        </li>
                    );
                })}
            </ul>
            <div className="schedule-conflict-actions">
                <div className="schedule-conflict-actions-row">
                    {showProceed && onProceed && (
                        <div className="schedule-conflict-btn-wrap">
                            <Button
                                severity="warning"
                                label={actionLoading ? 'Saving…' : proceedLabel}
                                className="schedule-conflict-btn border-0"
                                disabled={actionLoading}
                                onClick={onProceed}
                            />
                        </div>
                    )}
                    {onRequestApproval && (
                        <div className="schedule-conflict-btn-wrap">
                            <Button
                                severity="secondary"
                                label={actionLoading ? 'Sending…' : 'Request approval'}
                                className="schedule-conflict-btn border-0"
                                disabled={actionLoading}
                                onClick={() => onRequestApproval(items)}
                            />
                        </div>
                    )}
                </div>
                {onApproveTimeline && suggestCardId && (
                    <Button
                        severity="info"
                        label={actionLoading ? 'Loading…' : 'Review & save'}
                        className="schedule-conflict-btn schedule-conflict-btn-full border-0"
                        disabled={actionLoading}
                        onClick={() => onApproveTimeline(suggestCardId, items)}
                    />
                )}
            </div>
        </div>
    );
};

export default ScheduleConflictModal;
